/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { baseAuthHeaders } from "#/modules/auth/idp";

// One accessible Organization (internal scope = LICENSE). UI renders license_name as the
// Organization name and customer_name as the parent Territory (see RBAC terminology).
export type LicenseItem = {
  license_id: string;
  customer_id: string;
  customer_name: string;
  license_name: string;
  license_status: string;
  expires_at: string;
  effective_role: string;
};

type ListLicensesResponse = { items: LicenseItem[] };

// GET /xecguard/internal/v1/licenses — Organizations accessible to the caller, role-scoped
// (SYSTEM_ADMIN: all; TERRITORY_ADMIN: under their territory; ORG_*: their assigned orgs).
// Internal-Admin plane: BearerAuth only (no X-License-Id), so it works before one is chosen.
export default function listLicenses(
  { token }: { token: string },
): Promise<InternalResponse<ListLicensesResponse>> {
  return request()({
    url: "/xecguard/internal/v1/licenses",
    method: "GET",
    headers: baseAuthHeaders(token),
  }).then(
    (result: AxiosResponse<ListLicensesResponse>): InternalResponse<ListLicensesResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.message,
    success: false,
  }));
}
